import { Component, Output, Input, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'app-recover-popup',
  templateUrl: 'recover-popup.component.html',
  styleUrls: ['./recover-popup.component.less', '../shared/common.less'],
})
export class RecoverPopupComponent implements OnInit {
  @Input() email: string = 'toto@gmail.com';
  @Input() recoverSucceeded: boolean = true;
  @Output() closePopup: EventEmitter<boolean> = new EventEmitter<boolean>();

  cancelDetails($event) {
    if (
      $event.target.className === 'div-arriere-plan-action' ||
      $event.target.className === 'div-global-action'
    ) {
      this.closePopup.emit(false);
    }
  }

  close() {
    this.closePopup.emit(false);
  }

  ngOnInit() {
  }
}
